<!-- <section scId="SC1275" infiniteScroll [scrollWindow]="false"
         [infiniteScrollDistance]="scrollDistance" [infiniteScrollDisabled]="disableScroll"
         (scrolled)="onScroll()" [infiniteScrollContainer]=" channelWeb ? windowContainer : infiniteScrollContainer" attr.pdlPageComponentId="{{pdlPageComponentId}}" attr.pdlRepeatedComponent="{{pdlRepeatedComponent}}"> -->
<section
  scId="SC1275"
  infiniteScroll
  [scrollWindow]="false"
  [infiniteScrollDistance]="scrollDistance"
  [infiniteScrollDisabled]="disableScroll"
  (scrolled)="onScroll()"
  [infiniteScrollContainer]="windowContainer"
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <div *ngIf="contentData && configDataLoaded">
    <!-- <tmo-change-entry [aemContent]="contentData" (browseEntryChange)="clearData(); getHardgoodsDataOnEventChange($event)"
    [isBrowsePlan]="showUpdatedBrowseDevices"></tmo-change-entry> -->
    <tmo-junk-fee-banner [aemContent]="contentData"></tmo-junk-fee-banner>
    <tmo-change-entry
      [aemContent]="contentData"
      (browseEntryChange)="clearData(); navigateHome()"
    ></tmo-change-entry>
    <!-- Page Title Section Begins -->
    <div class="page-title filter-sort-component-task">
      <div class="container">
        <div class="row">
          <!-- Page Title -->
          <div class="col-12 col-md-8">
            <!-- <h2 *ngIf="!isRetail" class="m-t-xl m-b-xl">{{pageHeading || contentData?.pageHeading}}</h2> -->
            <h2 class="m-t-xl m-b-xl">{{ pageHeading || contentData?.pageHeading }}</h2>
            <!-- <h2 *ngIf="isRetail" class="m-t-xl m-b-xl">{{pageHeading || contentData?.retailPageHeading}}</h2> -->
          </div>

          <!-- Filter & Sort -->
          <div class="col-12 col-md-4 p-0" *ngIf="filters?.length > 0 || sorts?.length > 0">
            <div class="filter-sort-container">
              <tmo-hardgoods-filter-sort
                [isP10MCustomer]="isP10MCustomer"
                [selectedSort]="selectedSort"
                [sortCategories]="sorts"
                (updateSortResults)="updateSortRecords($event)"
                [updateCategoryFilterCount]="userDisplayFilter"
                [filterCategories]="filters"
                (filterCriteria)="selectedFilterCriteria($event)"
                [userFilter]="userDisplayFilter"
                [isAccessoryPage]="isAccessory"
                [isAccessoryDetailPage]="isACDP"
                [contentData]="contentData"
                (userFilterEmitter)="setDisplayFilter($event)"
              >
              </tmo-hardgoods-filter-sort>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Header Spacing -->
    <div *ngIf="contentData" tmoTitleHeaderSpacing></div>
    <!-- Compatible Accessories Section -->
    <div class="row" *ngIf="isAccessory">
      <div class="col-12">
        <div class="m-t-xl inline-block">
          <h3 id="find-compatible-heading">{{ contentData?.findCompatibleAccessories }}</h3>
          <div class="row">
            <div class="col-8 m-t-md">
              <tmo-input-autocomplete
                attr.aria-label="{{ contentData?.chooseYourDevice }}"
                id="accessory-auto-complete"
                [brands]="deviceSearchResultsAutoCompleteInput"
                [formControl]="findCompatibleAccessoriesFormControl"
                [placeHolder]="contentData?.chooseYourDevice"
              >
              </tmo-input-autocomplete>
            </div>
          </div>
        </div>
      </div>
      <hr class="col-12 divider m-t-xl" />
    </div>
    <!-- Sort -->
    <!-- TODO Need to check the UserStory-->
    <!-- <div *ngIf="sortApplied" class="row m-t-xl">
      <div class="col-6">
        <p class="lead bold">{{contentData?.sortedBy}}</p>
      </div>
    </div>
    <div *ngIf="sortApplied" class="row">
      <div class="col-6 col-md-4 col-lg-3 m-t-sm">
        <div class="tag">
          <span class="filtered pull-left text-ellipsis w-60">{{sortDisplay}}</span>
          <a href="javascript:void(0)" (click)="removeSort()" class="hover-magenta" id="cta-default-132"><i attr.aria-label="{{sortDisplay}} {{contentData?.dismiss}}" class="fa fa-times def icon-gray-dark icon-brand-hover pull-right m-r-sm m-l-sm"></i></a>
        </div>
      </div>
    </div> -->

    <div class="row" *ngIf="isAccessory && userDisplayFilter?.length > 0 && isACDP">
      <div class="col-12">
        <div class="m-t-xl inline-block">
          <h4>{{ contentData?.results }} ({{ resultsCount }})</h4>
        </div>
      </div>
    </div>

    <!-- Filter -->
    <div *ngIf="userDisplayFilter?.length > 0">
      <div class="row m-t-xl">
        <div class="col-6">
          <p class="lead bold">{{ contentData?.filteredBy }}</p>
        </div>
        <div class="col-6 text-end">
          <p class="">
            <a
              href="javascript:void(0)"
              attr.aria-label="{{ contentData?.clearAll }}"
              (click)="clearAllFilters()"
              id="cta-clear-all-2"
            >
              {{ contentData?.clearAll }}
            </a>
          </p>
        </div>
      </div>
      <div class="row">
        <div *ngFor="let filter of userDisplayFilter; let index = index">
          <div class="col-6 col-md-4 col-lg-3 m-t-sm">
            <div class="tag">
              <span class="filtered pull-left text-ellipsis w-60">{{
                filter?.type === priceRangeValue ? '$' + filter?.optionValue : filter?.optionValue
              }}</span>
              <a
                href="javascript:void(0)"
                attr.aria-label="{{ filter.optionValue }}"
                class="hover-magenta"
                (click)="clearFilter(filter, index)"
                id="cta-display-name_{{ ind }}"
              >
                <i
                  class="fa fa-times def icon-gray-dark icon-brand-hover pull-right m-r-sm m-l-sm"
                ></i
              ></a>
            </div>
          </div>
        </div>
      </div>
      <hr class="divider m-t-xl" />
    </div>
    <ng-container *ngIf="previousSelectedValues.length > 0 && isFilterApplied">
      <hr class="divider_quicklinks" />
    </ng-container>

    <!-- Page Title Section Ends -->

    <!-- <div class="row" [ngClass]="isRetail && !isAccessory ? 'dark-background' : ''"> -->
    <div class="row">
      <ng-container *ngIf="errorMessage">
        <div class="col-12 m-t-sm">
          <tmo-error-message-detail [errorMessage]="errorMessage"></tmo-error-message-detail>
        </div>
      </ng-container>
      <!-- <div class="col-4 m-t-xl text-end" *ngIf="!isP10MCustomer && showUpdatedBrowseDevices && !isAccessory">
          <p class="lead">
          <span class="pe-2" id="phoneToggle{{showDevices}}" [ngClass]="showDevices ? 'icon-magenta' :  ''">{{contentData?.phones}}</span>
          <a href="javascript:void(0)">
          <span class="co-toggle">
              <input aria-label="Toggle" id="phone-tablet-toggle" [checked]="!showDevices" name="toggle" type="checkbox"
              (click)="onClick($event.srcElement.checked)">
              <span class="switch change"></span>
          </span>
          </a><span id="tabletToggle{{!showDevices}}" [ngClass]="!showDevices ? 'icon-magenta' :  ''">{{contentData?.tablets}}</span></p>
      </div> -->

      <div *ngIf="!isStoreOpen" class="error-text col-12 m-t-lg m-l-md p-0">
        <tmo-error-message-detail
          [errorText]="contentData?.storeNotOpen"
        ></tmo-error-message-detail>
      </div>
      <ng-container
        class="error-text col-12 m-t-lg m-l-md p-0"
        *ngIf="!isAccessory && hardGoods?.length === 0 && !isLoading"
      >
        <tmo-error-message-detail
          [errorText]="contentData?.noResultsFound"
        ></tmo-error-message-detail>
      </ng-container>
    </div>
    <router-outlet (activate)="onActivate()"></router-outlet>

    <!-- <div *ngIf="hardGoods?.length > 0 && !isAccessory && !showUpdatedBrowseDevices; else noResultsFound"> -->
    <div *ngIf="hardGoods?.length > 0 && !isAccessory; else noResultsFound">
      <div *ngFor="let hardgood of hardGoods; let idx = index">
        <div *ngIf="idx % 3 == 0" class="row">
          <div
            *ngFor="let hardgood of hardGoods | loopUnroll: idx : 3"
            class="col-12 col-md-4 text-center"
            id="product-{{ hardgood?.offerId }}"
          >
            <tmo-browse-hardgood
              *ngIf="hardgood"
              [isSearchedProduct]="false"
              [hardgoodData]="hardgood"
              [disableCheckbox]="disableCheckbox"
              [isLineInFocus]="isLineInFocus"
              [isUpgrade]="isUpgrade"
              [isEditingUpgradeLine]="isEditingUpgradeLine"
              [isEditingNonLineDevice]="isEditingNonLineDevice"
              [disableCompareLink]="disableCompareLink"
              [isP10MCustomer]="isP10MCustomer"
              [isAuthenticated]="isAuthenticated"
              [contentData]="contentData"
              (onCheck)="onCheckboxClick($event)"
            ></tmo-browse-hardgood>
          </div>
        </div>

        <div *ngIf="idx % 3 == 0" class="d-none d-md-block">
          <!-- Disclaimer on every row -->
          <div class="row m-t-xl" *ngIf="false">
            <div class="col-12 text-center">
              <p class="legal">{{ contentData?.disclaimer }}</p>
            </div>
          </div>
          <!-- Divider after every row -->
          <div class="row m-t-lg">
            <div class="col-12">
              <hr class="divider" />
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showComponentSpinner && pageNumber !== 1" class="row">
        <div class="col-12 text-center m-t-xl">
          <tmo-inline-spinner [setDelay]="!showComponentSpinner"></tmo-inline-spinner>
        </div>
      </div>
    </div>
    <!-- <ng-container *ngIf="showUpdatedBrowseDevices">
    <div *ngIf="!isAccessory && hardGoods?.length" class="row dark-background pt-5" [ngClass]="isGlobalSearch ? 'device-height' : ''">
      <div class="col-12" *ngFor="let hardgood of hardGoods; let familyIndex = index">
        <div class="row box-align m-b-lg" *ngIf="familyIndex % 2 == 0">
        <div class="col-5 p-0 small-container xs-m-b-sm xs-m-t-sm"
                    *ngFor="let hardgood of hardGoods| loopUnroll: familyIndex : 2; let idx = index"
                    [ngClass]="toggleDetails[(idx+familyIndex)] === true ? 'tiles-selected b-b-n tiles-expanded' : ''">
          <tmo-retail-browse-hardgood *ngIf="hardgood"
                                [hardGoodDetails]="hardgood"
                                [contentData]="contentData"
                                [index]="familyIndex + idx"
                                [toggleDetails]="toggleDetails"
                                [isP10MCustomer]=isP10MCustomer
                                (deviceDetailIndex)="setDeviceDetailsIndex($event, familyIndex)"
                                (apiError)="setAPIError($event)"></tmo-retail-browse-hardgood>
        </div>
        </div>
        <div class="row col-12 ps-4 tiles-accordian-width" *ngIf="familyIndex % 2 == 0">
          <div class="col-12 xs-m-b-sm ps-2"
              *ngIf="(deviceRowIndex > -1 && deviceRowIndex === familyIndex) && toggleDetails[(deviceIndex)] === true">
            <tmo-retail-browse-hardgood-details [hardgoodData]="hardGoods[(deviceIndex)]" [index]="deviceIndex"
            [deviceDescription]="deviceDescription" [contentData]="contentData"
            [toggleDetails]="toggleDetails" (deviceIndex)="setDeviceDetailsIndex($event, familyIndex)"></tmo-retail-browse-hardgood-details>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showComponentSpinner && pageNumber !== 1" class="row">
      <div class="col-12 text-center m-t-xl">
        <tmo-inline-spinner [setDelay]="!showComponentSpinner"></tmo-inline-spinner>
      </div>
  </div>
    </ng-container> -->
    <ng-template *ngIf="!isAccessory" #noResultsFound>
      {{ contentData?.noResultsFound }}
    </ng-template>
  </div>
</section>
<!-- Spinner -->
<div *ngIf="pageNumber === 1 && isLoading">
  <tmo-spinner [setDelay]="!isLoading"></tmo-spinner>
</div>
<!-- <div class="row dark-background" *ngIf="!isLoading && isRetail && contentData ">
    <div class="col-12 m-t-xxl legal">
      <p class="legal">
        <tmo-see-more-see-less [textDisable]="disabled" [limit]="200"
                               [inputText]="contentData?.browseDevicesLegalText"
                               [seeMoreText]="'See more'" [seeLessText]="'See less'">
        </tmo-see-more-see-less>
      </p>
    </div>
  </div> -->
<!-- <div class="row" *ngIf="legalText?.length > 0 && !isLoading && !isRetail"> -->
<div class="row" *ngIf="legalText?.length > 0 && !isLoading">
  <div class="col-12">
    <tmo-container-holder [isDynamicContent]="legalText"> </tmo-container-holder>
  </div>
</div>
